import type { PopoverListItem } from '@o2d/popover-list';
import { get } from 'lit-translate';
import { ROOT_TYPE_UIDS } from '../../constants';
import type { IssueType } from '../../domain/entities/issue-type.entity';

/**
 * The row menu of an issue type in /by-type. It greys out what the backend refuses: a root is
 * neither edited nor deleted (roots are fixed rows, their names come from translations), and a
 * child is not deleted while the backend reports `canDelete === false` (live issues, children).
 * When the backend sent nothing, delete stays enabled and the command guard
 * decides.
 */
export function issueTypeRowMenu(issueType: IssueType): PopoverListItem[] {
    const isRoot = ROOT_TYPE_UIDS.includes(issueType.uid);

    return [
        { id: 'edit', label: get('ha-boards-view.row-title.edit'), type: 'item', disabled: isRoot },
        {
            id: 'delete',
            label: get('ha-boards-view.row-title.delete'),
            type: 'item',
            disabled: isRoot || issueType.canDelete === false,
        },
    ];
}
